import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export default new VueI18n({
	locale: "fr",
	fallbackLocale: "fr",
	messages: {
		fr: {
			"error.badUsage.generic": "Utilisation invalide de la formule.",
			"error.badUsage.generic.withReason": "Utilisation invalide de la formule ({0}).",
			"error.badUsage.tousVraisPar.requires.keys.and.condition": "La fonction tousVraisPar() requiert au moins une clé et une condition.",
			"error.badUsage.tousVraisPar.keys.required": "La fonction tousVraisPar() requiert au moins une clé non vide.",
			"error.badUsage.tousVraisPar.condition.required": "La condition de la fonction tousVraisPar() est obligatoire.",
			"error.badUsage.tousVraisPar.invalid.execution.level": "La fonction tousVraisPar() doit être exécutée depuis un niveau strictement supérieur à la portée groupée.",
			"error.badUsage.tousVraisPar.null.key": "La fonction tousVraisPar() ne peut pas regrouper sur une clé nulle.",
			"error.badUsage.tousVraisPar.invalid.placeholder": "La fonction tousVraisPar() utilise un placeholder invalide dans la condition."
		}
	},
	preserveDirectiveContent: true
});
